var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privilidge-tip"},[(!_vm.isLogin && !_vm.hasPrivilidge)?_c('div',{staticClass:"tip-container"},[_vm._v("\n    暂无权限查看文章详情，请\n    "),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.login}},[_vm._v("登录")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6d5097d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/modules/common/privilidge-out.vue
// module id = mjkB
// module chunks = 1